import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h1>404 Not Available</h1>
            <img src="not-found.jpg" alt="" />
        </div>
    );
};

export default NotFound;